var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.333V12a2 2 0 004 0v-.667m-3.334-8a1.333 1.333 0 112.667 0 4.667 4.667 0 012.666 4v2a2.667 2.667 0 001.334 2H2.666a2.666 2.666 0 001.333-2v-2a4.667 4.667 0 012.667-4z",
    stroke: "#1E1E5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNotifications;